// Create a new file, e.g., LeadDetailsComponent.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Divider,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
} from "@mui/material";
import CustomButton from "../CustomButton/CustomButton"; // Make sure to import your CustomButton component
import ShowAllStyles from "../../../screens/AllLeads/components/ShowAll/ShowAll.styles";
import { Phone } from "@mui/icons-material";
import moment from "moment";
import { store } from "../../../utils/store";
import { clickToCall } from "../../../screens/Team/components/ShowAll/ShowAllService";
import { useActiveIvrCalls, refreshActiveIvrCalls, seedActiveIvrCall } from "../../../utils/useActiveIvrCalls";
import { openErrorNotification, openSuccessNotification } from "../../../helpers/methods";
import {
  openSms,
  openWhatsApp,
  WHATSAPP_TEMPLATES,
} from "../../../helpers/phoneActions";
import YhSelect, { buildStageSelectGroups } from "../../../ui/YhSelect";
import { getStage } from "../../../screens/MetaData/components/MetaList/components/LeadStageData/LeadStageListService";
import YhMultiSelect from "../../../ui/YhMultiSelect";
import YhInput from "../../../ui/YhInput";
import YhDateTimePicker, {
  formatDisplayDateTime,
  formatRecordedAt,
  parseLocalDateTime,
} from "../../../ui/YhDateTimePicker";
import {
  assignChannelPartnerToLead,
  listAssignableChannelPartners,
} from "../../../services/channelPartnerService";
import { useSelector } from "react-redux";
import { selectActiveOrganizationId, setUuid } from "../../../redux/authSlice";
import {
  canAssignToSelf,
  canEditLeadSource,
  isNiOrLostStage,
} from "../../../helpers/salesLeadHelpers";
import StageReasonModal from "../StageReasonModal";
import {
  getRemark,
  saveRemark as saveRemarkApi,
  updateRemark,
} from "../../../screens/MyLead/components/ShowAll/ShowAllService";
import {
  getReminder,
  updateReminder,
} from "../../../screens/AllLeads/components/ShowAll/ShowAllService";
import {
  resolveOrgName,
  useOrgNameMap,
} from "../../../Shared/Organization/OrganizationSelect";
import {
  assignToMembers,
  changeAt,
  getAllTeamMembersData,
} from "../../../screens/AllLeads/components/ShowAll/ShowAllService";
import {
  loadViewerAssignScope,
  ViewerAssignScope,
} from "../../../helpers/assignmentScope";

/** Website leads store dynamicFields as JSON object/string; CRM forms use [{name,answer}] */
function normalizeAdditionalFields(raw: any): Array<{ name: string; answer: any }> {
  let value = raw;
  if (value == null || value === "") return [];
  if (typeof value === "string") {
    try {
      value = JSON.parse(value);
    } catch {
      return [];
    }
  }
  if (Array.isArray(value)) {
    return value
      .map((e: any) => ({
        name: e?.name || e?.label || "",
        answer: e?.answer ?? e?.value ?? "",
      }))
      .filter((e) => e.name);
  }
  if (typeof value === "object") {
    return Object.entries(value).map(([name, answer]) => ({ name, answer }));
  }
  return [];
}

const LeadDetailsComponent: React.FC<any> = ({
  dynamicGridValue,
  handleAutocompleteChange,
  handleAutocompleteChangeCustom,
  handleOptionCheckboxChange,
  selectedOptions,
  leadOption,
  leadOptionMembers,
  handleOptionCheckboxChange1,
  selectedOptionsMembers,
  handleChangeRadio,
  reminderStatus,
  setReminderStatus,
  setReminderData,
  currentDateTime,
  handleDateTimeChange,
  handelAssignToUser,
  handleAssignToMe: handleAssignToMeProp,
  handelSideSave,
  reminderData,
  responseValuereminder,
  leadReminders,
  addinationalValue,
  stageData,
  isMyLead,
  isTeamLead,
  handelSideSaveRemark,
  responseValueremark,
  handelRemoveReminder,
  onRemindersChange,
  openCustomer,
  setLeadData,
  handleAssignToMember,
  handleTeamMultiChange,
  handleMemberMultiChange,
  allSatgedata,
  setSelectedTab,
  customerDetail,
  sourceOptions,
  onAssigned,
}) => {
  const classes = ShowAllStyles;
  const [assignScope, setAssignScope] = useState<ViewerAssignScope | null>(null);
  const [leaderMembers, setLeaderMembers] = useState<
    { id: string; label: string }[]
  >([]);
  const [leaderMemberIds, setLeaderMemberIds] = useState<string[]>([]);
  const [assigning, setAssigning] = useState(false);
  const additionalFields = normalizeAdditionalFields(addinationalValue);
  const activeOrgId = useSelector(selectActiveOrganizationId);
  const effectiveOrgId = useMemo(() => {
    const fromLead = String(dynamicGridValue?.organizationId || "").trim();
    if (fromLead && fromLead !== "undefined" && fromLead !== "null") {
      return fromLead;
    }
    const fromActive = String(activeOrgId || "").trim();
    if (
      fromActive &&
      fromActive !== "all" &&
      fromActive !== "*" &&
      fromActive !== "undefined"
    ) {
      return fromActive;
    }
    return "";
  }, [dynamicGridValue?.organizationId, activeOrgId]);

  const [cpOptions, setCpOptions] = useState<any[]>([]);
  const [selectedCpId, setSelectedCpId] = useState(
    String(dynamicGridValue?.channelPartnerId || "")
  );
  const [savingCp, setSavingCp] = useState(false);
  const [assignTouched, setAssignTouched] = useState(false);
  const [cpTouched, setCpTouched] = useState(false);
  const [editingNoteId, setEditingNoteId] = useState("");
  const [savingPanel, setSavingPanel] = useState(false);
  const [noteList, setNoteList] = useState<any[]>([]);
  const orgNameMap = useOrgNameMap();
  const orgLabel = resolveOrgName(orgNameMap, effectiveOrgId);
  const [stageReason, setStageReason] = useState<{
    open: boolean;
    stage: string;
  }>({ open: false, stage: "" });
  const [savingStageReason, setSavingStageReason] = useState(false);

  const auth = store.getState().auth || {};
  const allowAssignToSelf = canAssignToSelf(auth);
  const allowEditSource = canEditLeadSource(auth);
  const handleAssignToMe = allowAssignToSelf ? handleAssignToMeProp : undefined;

  useEffect(() => {
    setSelectedCpId(String(dynamicGridValue?.channelPartnerId || ""));
    setAssignTouched(false);
    setCpTouched(false);
    setEditingNoteId("");
  }, [dynamicGridValue?._id, dynamicGridValue?.channelPartnerId]);

  useEffect(() => {
    const list = Array.isArray(responseValueremark?.value)
      ? responseValueremark.value
      : [];
    setNoteList(list);
  }, [dynamicGridValue?._id, responseValueremark]);

  useEffect(() => {
    if (!effectiveOrgId) {
      setCpOptions([]);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await listAssignableChannelPartners(
          String(effectiveOrgId),
          dynamicGridValue?.projectId
            ? String(dynamicGridValue.projectId)
            : undefined
        );
        const list = res?.data || res || [];
        if (!cancelled) setCpOptions(Array.isArray(list) ? list : []);
      } catch (_) {
        if (!cancelled) setCpOptions([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [effectiveOrgId, dynamicGridValue?.projectId]);

  const handleSaveChannelPartner = async (quiet = false) => {
    if (!dynamicGridValue?._id) return;
    if (!effectiveOrgId) {
      openErrorNotification(
        "Set organization on this lead (or switch to a Yathaw org) before assigning a Channel Partner"
      );
      return;
    }
    setSavingCp(true);
    try {
      await assignChannelPartnerToLead({
        leadId: String(dynamicGridValue._id),
        channelPartnerId: selectedCpId || undefined,
        clear: !selectedCpId,
        organizationId: effectiveOrgId,
      });
      if (!quiet) {
        openSuccessNotification(
          selectedCpId ? "Channel Partner assigned" : "Channel Partner cleared"
        );
      }
      if (typeof setLeadData === "function") {
        setLeadData({
          ...dynamicGridValue,
          organizationId: dynamicGridValue.organizationId || effectiveOrgId,
          channelPartnerId: selectedCpId || null,
          isFromChannelPartner: !!selectedCpId,
        });
      }
    } catch (e: any) {
      openErrorNotification(e?.message || "Failed to assign Channel Partner");
    } finally {
      setSavingCp(false);
    }
  };

  useEffect(() => {
    let cancelled = false;
    loadViewerAssignScope().then((scope) => {
      if (!cancelled) setAssignScope(scope);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const clockHHMM = (time: string) => {
    const match = String(time || "")
      .trim()
      .match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)?/i);
    if (!match) return "";
    let hours = parseInt(match[1], 10);
    const minutes = match[2];
    const period = (match[3] || "").toUpperCase();
    if (period === "PM" && hours !== 12) hours += 12;
    if (period === "AM" && hours === 12) hours = 0;
    return `${String(hours).padStart(2, "0")}:${minutes}`;
  };
  const reminderStamp = (item: any) =>
    `${String(item?.date || "")} ${clockHHMM(item?.time)}`;
  const sortReminders = (list: any[]) =>
    [...(list || [])].sort((a: any, b: any) =>
      reminderStamp(b).localeCompare(reminderStamp(a))
    );
  const [panelReminders, setPanelReminders] = useState<any[]>([]);

  const clearReminderForm = () => {
    setReminderStatus?.("No Reminder");
    setReminderData?.((prev: any) => ({
      ...(prev || {}),
      _id: "",
      title: "",
      date: "",
      time: "",
      notes: "",
    }));
  };

  const fillReminderForm = (item: any) => {
    const date = String(item?.date || "").slice(0, 10);
    const time = clockHHMM(item?.time);
    setReminderStatus?.("Schedule a Reminder");
    setReminderData?.((prev: any) => ({
      ...(prev || {}),
      _id: item?._id || "",
      title: item?.title || "",
      date,
      time,
      notes: item?.notes || "",
    }));
  };

  const applyReminderList = (rows: any[]) => {
    const next = sortReminders(
      (Array.isArray(rows) ? rows : []).filter(
        (item: any) => String(item?.status ?? "1") !== "0"
      )
    );
    setPanelReminders(next);
    onRemindersChange?.(next);
  };

  const refreshReminderList = async (leadId: string) => {
    if (!leadId) return;
    try {
      const refreshed = await getReminder(leadId);
      applyReminderList(Array.isArray(refreshed?.data) ? refreshed.data : []);
    } catch {
      /* keep current list */
    }
  };

  useEffect(() => {
    clearReminderForm();
    setPanelReminders([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dynamicGridValue?._id]);

  useEffect(() => {
    const leadId = String(dynamicGridValue?._id || "");
    const matchesLead = (item: any) =>
      !item?.leadId || String(item.leadId) === leadId;
    const fromApi = (
      Array.isArray(responseValuereminder?.value)
        ? responseValuereminder.value
        : []
    ).filter(matchesLead);
    const fromList = (
      Array.isArray(leadReminders) ? leadReminders : []
    ).filter(matchesLead);
    const list = fromApi.length ? fromApi : fromList;
    setPanelReminders(
      sortReminders(
        list.filter((item: any) => String(item?.status ?? "1") !== "0")
      )
    );
  }, [dynamicGridValue?._id, responseValuereminder, leadReminders]);

  useEffect(() => {
    if (assignScope?.role !== "leader" || !assignScope.teamIds.length) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await getAllTeamMembersData({
          team_id: assignScope.teamIds,
          lead_id: dynamicGridValue?._id,
        });
        const rows =
          (res?.data || []).flatMap((team: any) =>
            (team?.team_members || [])
              .map((mem: any) => {
                const user = mem?.users?.[0];
                const id = String(user?._id || mem?.userId || "")
                  .replace(/['"]/g, "")
                  .trim();
                if (!id) return null;
                return { id, label: user?.name || "Member" };
              })
              .filter(Boolean)
          ) || [];
        const unique = Array.from(
          new Map(rows.map((m: { id: string }) => [m.id, m])).values()
        ) as { id: string; label: string }[];
        if (!cancelled) {
          setLeaderMembers(unique);
          const already = (selectedOptionsMembers || [])
            .map((m: any) => String(m?.id || ""))
            .filter((id: string) => unique.some((m) => m.id === id));
          setLeaderMemberIds(already);
        }
      } catch {
        if (!cancelled) setLeaderMembers([]);
      }
    })();
    handleTeamMultiChange?.(assignScope.teamIds);
    return () => {
      cancelled = true;
    };
    // Reload when the open lead or the viewer's teams change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignScope, dynamicGridValue?._id]);

  const lockTeam =
    assignScope?.role === "leader" || assignScope?.role === "member";
  const lockMember = assignScope?.role === "member";

  const lockedTeamOptions = (assignScope?.teams || []).map((team) => {
    const fromList = (leadOption || []).find(
      (option: any) => String(option.id) === String(team.id)
    );
    return {
      label: fromList?.label || team.label,
      value: String(team.id),
    };
  });

  const uniqueLeadOptionMembers = Array.from(
    new Map(
      (leadOptionMembers || []).map((member: any) => [
        String(member.id),
        { ...member, id: String(member.id) },
      ])
    ).values()
  );

  const onTeamMultiChange = (values: Array<string | number>) => {
    if (handleTeamMultiChange) {
      handleTeamMultiChange(values);
      return;
    }
    // Fallback for pages that still use checkbox handlers
    const nextIds = new Set(values.map(String));
    (leadOption || []).forEach((option: any) => {
      const id = String(option.id);
      const shouldSelect = nextIds.has(id);
      const isSelected = option?.selected === 1;
      if (shouldSelect === isSelected) return;
      handleOptionCheckboxChange?.(option, shouldSelect)?.({
        target: { checked: shouldSelect },
      });
    });
  };

  const onMemberMultiChange = (values: Array<string | number>) => {
    if (handleMemberMultiChange) {
      handleMemberMultiChange(values);
      return;
    }
    const nextIds = new Set(values.map(String));
    uniqueLeadOptionMembers.forEach((option: any) => {
      const id = String(option.id);
      const shouldSelect = nextIds.has(id);
      const isSelected = option?.selected === 1;
      if (shouldSelect === isSelected) return;
      if (handleAssignToMember) {
        handleAssignToMember(option, shouldSelect);
      } else {
        handleOptionCheckboxChange1?.(option, shouldSelect)?.({
          target: { checked: shouldSelect },
        });
      }
    });
  };

  const flattenStageData = (
    data: any[]
  ): { label: string; isParent: boolean }[] => {
    const result: { label: string; isParent: boolean }[] = [];

    const extractStageNames = (stages: any[]) => {

      stages.forEach((stage) => {
        if (stage.stage_Name) {
          result.push({ label: stage.stage_Name, isParent: true }); // Parent entry
        }
        if (stage.sub_Stage_name && Array.isArray(stage.sub_Stage_name)) {
          stage.sub_Stage_name.forEach((subStage: any) => {
            result.push({ label: subStage.stage_Name, isParent: false }); // Child entry
          });
        }
      });
    };

    extractStageNames(data);
    return result;
  };

  const [stageTree, setStageTree] = useState<any[]>([]);
  useEffect(() => {
    const fromParent = Array.isArray(allSatgedata) ? allSatgedata : [];
    if (fromParent.length) {
      setStageTree(fromParent);
      return;
    }
    if (!dynamicGridValue?._id) return;
    let cancelled = false;
    getStage()
      .then((res: any) => {
        if (!cancelled) setStageTree(res?.data || []);
      })
      .catch(() => {
        if (!cancelled) setStageTree([]);
      });
    return () => {
      cancelled = true;
    };
  }, [dynamicGridValue?._id, allSatgedata]);

  const stageOptions = flattenStageData(stageTree);
  const stageGroups = buildStageSelectGroups(stageTree);
  const [autocompleteValue, setAutocompleteValue] = useState<
    { label: string; isParent: boolean } | undefined
  >(
    stageOptions.find((option) => option.label === dynamicGridValue?.stage)
  );

  useEffect(() => {
    const current = String(dynamicGridValue?.stage || "").trim();
    const next =
      flattenStageData(stageTree).find((option) => option.label === current) ||
      (current ? { label: current, isParent: false } : undefined);
    setAutocompleteValue((prev) =>
      prev?.label === next?.label ? prev : next
    );
  }, [dynamicGridValue?._id, dynamicGridValue?.stage, stageTree]);
  const [calling, setCalling] = useState(false);
  const { hasActiveCall, primary } = useActiveIvrCalls();
  const callBusy = calling || hasActiveCall;

  const requestStageChange = (label: string) => {
    if (!label) return;
    const current = String(
      autocompleteValue?.label || dynamicGridValue?.stage || ""
    ).trim();
    if (label === current) return;
    setAutocompleteValue({ label, isParent: false });
    if (isNiOrLostStage(label)) {
      setStageReason({ open: true, stage: label });
      return;
    }
    handleAutocompleteChange("stage", label, dynamicGridValue);
  };

  const confirmStageReason = async (reason: string) => {
    const leadId = dynamicGridValue?._id || dynamicGridValue?.row?._id;
    if (!leadId || !stageReason.stage) return;
    try {
      setSavingStageReason(true);
      // Backend requires reason on the stage PUT for NI/Lost; it also stores the remark.
      await handleAutocompleteChange(
        "stage",
        stageReason.stage,
        dynamicGridValue,
        { reasonAlreadySaved: true, reason }
      );
      setStageReason({ open: false, stage: "" });
    } catch (e: any) {
      openErrorNotification(e?.message || "Failed to save reason");
    } finally {
      setSavingStageReason(false);
    }
  };

  const normalizePhoneNumber = (phone: any) => {
    if (!phone) return "";
    const raw = String(phone);
    // Masked display numbers are not dialable from the client
    if (raw.includes("*")) return "";
    const digitsOnly = raw.replace(/\D/g, "");
    if (!digitsOnly) return "";
    if (digitsOnly.startsWith("91") && digitsOnly.length === 12) {
      return `+${digitsOnly}`;
    }
    if (digitsOnly.length === 10) {
      return `+91${digitsOnly}`;
    }
    return `+${digitsOnly}`;
  };

  const getMessagingPhone = () => {
    const raw =
      dynamicGridValue?.leadPhoneFull ||
      dynamicGridValue?.leadPhone ||
      "";
    return normalizePhoneNumber(raw);
  };

  const handleWhatsApp = (templateId?: string) => {
    const phone = getMessagingPhone();
    if (!phone) {
      openErrorNotification("Valid phone number required for WhatsApp");
      return;
    }
    const leadName = dynamicGridValue?.leadName || "";
    const tpl = WHATSAPP_TEMPLATES.find((t) => t.id === templateId);
    openWhatsApp(phone, tpl ? tpl.build(leadName) : undefined);
  };

  const handleSms = () => {
    const phone = getMessagingPhone();
    if (!phone) {
      openErrorNotification("Valid phone number required for SMS");
      return;
    }
    openSms(phone);
  };

  const handleClickToCall = async () => {
    if (calling) return;
    if (hasActiveCall) {
      openErrorNotification(
        `Call already in progress (${primary?.durationFormatted || "live"}). Wait until it ends.`
      );
      return;
    }
    const leadId = dynamicGridValue?._id || dynamicGridValue?.id || "";
    const rawPhone =
      dynamicGridValue?.leadPhoneFull ||
      dynamicGridValue?.leadPhone ||
      "";
    const dialable = normalizePhoneNumber(rawPhone);
    const uuid = store.getState().auth.uuid;

    if (!uuid) {
      openErrorNotification("Caller ID (uuid) missing for this user");
      return;
    }
    // Team/masked views: send leadId so backend resolves full number from DB
    if (!dialable && !leadId) {
      openErrorNotification("Valid phone number required to call");
      return;
    }

    try {
      setCalling(true);
      const auth = store.getState().auth;
      const response = await clickToCall({
        leadPhone: dialable || rawPhone,
        leadId,
        leadName:
          dynamicGridValue?.leadName ||
          dynamicGridValue?.name ||
          "",
        agentName: auth.userName || "",
        uuid,
      });
      if (response?.success === 0 || response?.success === false || response?.error) {
        openErrorNotification(
          response?.message || response?.error || "Unable to place call"
        );
        return;
      }
      if (response?.uuid && String(response.uuid) !== String(uuid)) {
        store.dispatch(setUuid(String(response.uuid)));
      }
      openSuccessNotification(response?.message || "Call initiated");
      seedActiveIvrCall({
        _id: response?.activeCallId || response?.data?.activeCallId,
        status: "initiated",
        leadName:
          dynamicGridValue?.leadName ||
          dynamicGridValue?.name ||
          "",
        leadId: String(leadId || ""),
        customerNumber: dialable || rawPhone,
        agentUserId: response?.uuid || uuid,
        uniqueCallId: response?.unique_id || response?.data?.unique_id,
        referenceId: response?.reference_id || response?.referenceId,
      });
      await refreshActiveIvrCalls();
    } catch (e: any) {
      openErrorNotification(e?.message || "Unable to place call");
    } finally {
      setCalling(false);
    }
  };

  const refreshNotes = async (leadId: string) => {
    const response = await getRemark(leadId);
    setNoteList(Array.isArray(response?.data) ? response.data : []);
  };

  const saveAssignment = async () => {
    if (lockMember) return true;
    const leadId =
      dynamicGridValue?._id ||
      dynamicGridValue?.row?._id ||
      dynamicGridValue?.id;
    if (!leadId) {
      openErrorNotification("Lead not found");
      return false;
    }
    if (assignScope?.role === "leader") {
      const teamIds = (assignScope.teamIds || []).map(String);
      const memberIds = leaderMemberIds.filter(Boolean);
      if (!teamIds.length && !memberIds.length) {
        openErrorNotification("No team on your login");
        return false;
      }
      setAssigning(true);
      try {
        if (teamIds.length) {
          const teamRes = await changeAt({
            id: leadId,
            AssignTo: teamIds.map((tid) => `'${tid}'`).join(","),
          });
          if (!(teamRes?.success === 1 || teamRes?.success === true)) {
            openErrorNotification(teamRes?.message || "Failed to assign team");
            return false;
          }
        }
        if (memberIds.length) {
          const response = await assignToMembers({
            id: leadId,
            AssignToUser: memberIds.join(","),
            AssignTo: teamIds.length
              ? teamIds.map((tid) => `'${tid}'`).join(",")
              : undefined,
            stage:
              dynamicGridValue?.stage ||
              dynamicGridValue?.row?.stage ||
              "Initial",
          });
          if (!(response?.success === 1 || response?.success === true)) {
            openErrorNotification(response?.message || "Failed to assign members");
            return false;
          }
        }
        onAssigned?.();
        return true;
      } catch (error: any) {
        openErrorNotification(error?.message || "Failed to assign");
        return false;
      } finally {
        setAssigning(false);
      }
    }
    handelAssignToUser(dynamicGridValue);
    return true;
  };

  const savePanel = async () => {
    const leadId = String(dynamicGridValue?._id || "");
    const noteText = String(reminderData?.notes_remark || "").trim();
    const reminderReady =
      reminderStatus === "Schedule a Reminder" &&
      (reminderData?.title || reminderData?.date);
    const willAssign = assignTouched && !isMyLead && !lockMember;
    const willNote = Boolean(editingNoteId || noteText);
    if (!willAssign && !cpTouched && !willNote && !reminderReady) {
      openErrorNotification("Nothing to save");
      return;
    }
    setSavingPanel(true);
    try {
      if (willAssign) {
        const ok = await saveAssignment();
        if (!ok) return;
        setAssignTouched(false);
      }
      if (cpTouched) {
        await handleSaveChannelPartner(true);
        setCpTouched(false);
      }
      if (editingNoteId) {
        if (!noteText) {
          openErrorNotification("Note cannot be empty");
          return;
        }
        const res = await updateRemark({
          id: editingNoteId,
          notes: noteText,
          status: "1",
        });
        if (!(res?.success === 1 || res?.success === true)) {
          openErrorNotification(res?.message || "Could not update the note");
          return;
        }
        setEditingNoteId("");
        setReminderData?.((prev: any) => ({ ...(prev || {}), notes_remark: "" }));
        if (leadId) await refreshNotes(leadId);
      } else if (noteText && leadId) {
        const res = await saveRemarkApi({
          leadId,
          notes: noteText,
          date: new Date().toLocaleDateString(),
          time: new Date().toLocaleTimeString(),
          title: "",
        });
        if (!(res?.success === 1 || res?.success === true)) {
          openErrorNotification(res?.message || "Could not save the note");
          return;
        }
        setReminderData?.((prev: any) => ({ ...(prev || {}), notes_remark: "" }));
        await refreshNotes(leadId);
      }
      if (reminderReady) {
        const reminderPayload = {
          ...reminderData,
          leadId,
          status: "1",
          id: reminderData?._id || "",
        };
        if (reminderData?._id) {
          const updated = await updateReminder(reminderPayload);
          if (!(updated?.success === 1 || updated?.success === true)) {
            openErrorNotification(updated?.message || "Could not update the reminder");
            return;
          }
          applyReminderList(
            panelReminders.map((item: any) =>
              String(item?._id) === String(reminderPayload._id)
                ? { ...item, ...reminderPayload }
                : item
            )
          );
        } else if (typeof handelSideSave === "function") {
          await handelSideSave(reminderPayload);
        }
        await refreshReminderList(leadId);
        clearReminderForm();
      }
      openSuccessNotification("Saved");
    } catch (error: any) {
      openErrorNotification(error?.message || "Could not save");
    } finally {
      setSavingPanel(false);
    }
  };

  const sortedNotes = [...(noteList || [])].sort((a: any, b: any) => {
    const stamp = (item: any) => {
      const raw = item?.createdAt || item?.updatedAt;
      const time = raw ? new Date(raw).getTime() : NaN;
      return Number.isNaN(time) ? 0 : time;
    };
    return stamp(b) - stamp(a);
  });

  const formatNoteWhen = (item: any) => formatRecordedAt(item);

  const visibleReminders = panelReminders;

  const formatReminderWhen = (item: any) => {
    const date = String(item?.date || "").trim();
    const time = clockHHMM(item?.time);
    if (/^\d{4}-\d{2}-\d{2}$/.test(date) && time) {
      const local = parseLocalDateTime(`${date}T${time}`);
      if (local) return formatDisplayDateTime(local);
    }
    return [date, String(item?.time || "").trim()].filter(Boolean).join(" ");
  };

  return (
    <>
      <Grid
        container
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"space-evenly"}
        gap={"5px"}
      >
        <Grid item xs={12}>
          <Box>
            <Typography sx={classes.leadName}>
              {dynamicGridValue?.leadName}
            </Typography>
            <Box sx={classes.infoSection}>
              <Typography>
                {moment(
                  (dynamicGridValue?.updatedAt || "").split("T")[0] ||
                    undefined
                ).format("DD MMM, YYYY")}
              </Typography>
              {Array.isArray(sourceOptions) &&
              sourceOptions.length > 0 &&
              allowEditSource ? (
                <Box sx={{ mt: 0.5, minWidth: 160 }}>
                  <YhSelect
                    placeholder="Select source"
                    searchPlaceholder="Search sources..."
                    showOptionIcon={false}
                    searchable
                    value={dynamicGridValue?.source || ""}
                    options={sourceOptions.map((s: string) => ({
                      label: s,
                      value: s,
                    }))}
                    onChange={(e) => {
                      const next = e.target.value;
                      if (next) {
                        handleAutocompleteChange?.(
                          "source",
                          next,
                          dynamicGridValue
                        );
                      }
                    }}
                  />
                </Box>
              ) : (
                <Typography sx={classes.faceBook}>
                  {dynamicGridValue.source}
                </Typography>
              )}
            </Box>
            <Box
              sx={{
                ...classes.callSection,
                opacity: callBusy ? 0.55 : 1,
                pointerEvents: callBusy ? "none" : "auto",
                cursor: callBusy ? "not-allowed" : "pointer",
              }}
              mt={1}
              onClick={handleClickToCall}
              title={
                hasActiveCall
                  ? `Ongoing call ${primary?.durationFormatted || ""}`
                  : "Start IVR call"
              }
            >
              <Box sx={classes.callBox}>
                <Box sx={classes.phoneIcon}><Phone /></Box>
                <span>
                  {calling
                    ? "Calling…"
                    : hasActiveCall
                      ? `On call ${primary?.durationFormatted || ""}`
                      : "Call"}
                </span>
              </Box>
            </Box>
            <Box
              mt={1}
              sx={{ display: "flex", flexWrap: "wrap", gap: 1, alignItems: "center" }}
            >
              <Box
                sx={{
                  ...classes.callSection,
                  cursor: "pointer",
                  flex: "1 1 auto",
                  minWidth: 100,
                }}
                onClick={() => handleWhatsApp()}
                title="Open WhatsApp"
              >
                <Box sx={classes.callBox}>
                  <span style={{ fontWeight: 600, color: "#25D366" }}>WA</span>
                  <span>WhatsApp</span>
                </Box>
              </Box>
              <Box
                sx={{
                  ...classes.callSection,
                  cursor: "pointer",
                  flex: "1 1 auto",
                  minWidth: 80,
                }}
                onClick={handleSms}
                title="Send SMS"
              >
                <Box sx={classes.callBox}>
                  <span>SMS</span>
                </Box>
              </Box>
              <select
                aria-label="WhatsApp template"
                defaultValue=""
                onChange={(e) => {
                  const id = e.target.value;
                  if (!id) return;
                  handleWhatsApp(id);
                  e.target.value = "";
                }}
                style={{
                  flex: "1 1 100%",
                  borderRadius: 8,
                  border: "1px solid #E5E7EB",
                  padding: "6px 8px",
                  fontSize: 12,
                  color: "#4D5369",
                }}
              >
                <option value="">WhatsApp template…</option>
                {WHATSAPP_TEMPLATES.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.label}
                  </option>
                ))}
              </select>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Divider></Divider>
        </Grid>
        <Grid item xs={12}>
          <Box>
            <Typography sx={classes.leadName}>Lead Management</Typography>
            {/* <Box sx={classes.infoSection}>
              <Typography>Manage Lead Progression & Ownership</Typography>
            </Box> */}
          </Box>
          {!isTeamLead ?
            <><Box mt={1}>
              <Typography sx={classes.leadName1}>Stage</Typography>
            </Box><Box sx={classes.inputPart}>
                <YhSelect
                  placeholder="Select stage"
                  searchPlaceholder="Search stages..."
                  searchable
                  showOptionIcon={false}
                  value={autocompleteValue?.label || dynamicGridValue?.stage || ""}
                  groups={stageGroups}
                  onChange={(e) => {
                    const label = e.target.value;
                    if (!label) return;
                    requestStageChange(label);
                  }}
                />
              </Box></>
            : ""}
          {!isMyLead ? (
            <>
              <Box mt={1}>
                <Typography sx={classes.leadName1}>Assigned To</Typography>
              </Box>
              <Box sx={classes.inputPart}>
                <YhMultiSelect
                  placeholder={
                    lockTeam
                      ? lockedTeamOptions.length
                        ? "Your team"
                        : "No team on your login"
                      : (leadOption || []).length
                        ? "Select teams..."
                        : "No teams loaded — refresh lead"
                  }
                  searchPlaceholder="Search teams..."
                  showOptionIcon={false}
                  showSelectAll={!lockTeam}
                  maxVisibleChips={2}
                  clearable={!lockTeam}
                  disabled={lockTeam}
                  options={
                    lockTeam
                      ? lockedTeamOptions
                      : (leadOption || []).map((option: any) => ({
                          label: option.label,
                          value: String(option.id),
                        }))
                  }
                  value={
                    lockTeam
                      ? (assignScope?.teamIds || []).map(String)
                      : (selectedOptions || []).map((o: any) => String(o.id))
                  }
                  onChange={
                    lockTeam
                      ? undefined
                      : (values) => {
                          setAssignTouched(true);
                          onTeamMultiChange?.(values);
                        }
                  }
                />
              </Box>
              <Box mt={1}>
                <Typography sx={classes.leadName1}>
                  Assigned To Member
                </Typography>
              </Box>
              <Box sx={classes.inputPart}>
                <YhMultiSelect
                  placeholder={
                    lockMember
                      ? assignScope?.userName || "You"
                      : assignScope?.role === "leader"
                        ? leaderMembers.length
                          ? "Select members..."
                          : "Loading your team members..."
                        : (uniqueLeadOptionMembers || []).length ||
                            (selectedOptionsMembers || []).length
                          ? "Select members..."
                          : !(selectedOptions || []).length
                            ? "Select teams first (or Assign to me)"
                            : "Select members..."
                  }
                  searchPlaceholder="Search members..."
                  showOptionIcon={false}
                  showSelectAll={!lockMember && assignScope?.role !== "member"}
                  maxVisibleChips={1}
                  clearable={!lockMember}
                  disabled={lockMember}
                  options={
                    lockMember
                      ? [
                          {
                            label: assignScope?.userName || "You",
                            value: String(assignScope?.userId || ""),
                          },
                        ]
                      : assignScope?.role === "leader"
                        ? leaderMembers.map((member) => ({
                            label: member.label,
                            value: member.id,
                          }))
                        : (() => {
                            const opts = uniqueLeadOptionMembers.map(
                              (option: any) => ({
                                label: option.label,
                                value: String(option.id),
                              })
                            );
                            const seen = new Set(
                              opts.map((o) => String(o.value))
                            );
                            (selectedOptionsMembers || []).forEach((m: any) => {
                              const id = String(m?.id ?? "");
                              if (id && !seen.has(id)) {
                                opts.push({
                                  label: m.label || id,
                                  value: id,
                                });
                                seen.add(id);
                              }
                            });
                            return opts;
                          })()
                  }
                  value={
                    lockMember
                      ? [String(assignScope?.userId || "")].filter(Boolean)
                      : assignScope?.role === "leader"
                        ? leaderMemberIds
                        : (selectedOptionsMembers?.length
                            ? selectedOptionsMembers
                            : uniqueLeadOptionMembers.filter(
                                (o: any) => o?.selected === 1
                              )
                          ).map((o: any) => String(o.id))
                  }
                  onChange={
                    lockMember
                      ? undefined
                      : assignScope?.role === "leader"
                        ? (values) => {
                            const next = (values || []).map(String);
                            setAssignTouched(true);
                            setLeaderMemberIds(next);
                            handleMemberMultiChange?.(next);
                          }
                        : (values) => {
                            setAssignTouched(true);
                            onMemberMultiChange?.(values);
                          }
                  }
                />
              </Box>
              {lockMember ? (
                <Typography sx={{ mt: 0.5, fontSize: 11, color: "#6B7280" }}>
                  Your login shows only your team and your name.
                </Typography>
              ) : assignScope?.role === "leader" ? (
                <Typography sx={{ mt: 0.5, fontSize: 11, color: "#6B7280" }}>
                  Your team is fixed. You can assign any member of your team.
                </Typography>
              ) : null}
              {typeof handleAssignToMe === "function" ? (
                <button
                  type="button"
                  className="mt-2 text-xs font-semibold text-[#841C39]"
                  onClick={() => handleAssignToMe(dynamicGridValue)}
                >
                  Assign to me
                </button>
              ) : null}
              <Box mt={2}>
                <Typography sx={classes.leadName1}>Channel Partner</Typography>
              </Box>
              {!effectiveOrgId ? (
                <Typography sx={{ mt: 0.5, fontSize: 12, color: "#9CA3AF" }}>
                  Organization not set — switch active org to Yathaw (or set org
                  on this lead) to list Channel Partners.
                </Typography>
              ) : (
                <>
                  {orgLabel ? (
                    <Typography
                      sx={{ mt: 0.5, mb: 0.5, fontSize: 11, color: "#6B7280" }}
                    >
                      {orgLabel}
                    </Typography>
                  ) : null}
                  <Box sx={classes.inputPart}>
                    <YhSelect
                      placeholder="Select channel partner..."
                      searchable
                      value={selectedCpId}
                      onChange={(e) => {
                        setCpTouched(true);
                        setSelectedCpId(e.target.value);
                      }}
                      options={[
                        { label: "— None —", value: "" },
                        ...cpOptions.map((c: any) => ({
                          label: `${c.firmName} (${c.phone})`,
                          value: String(c._id),
                        })),
                      ]}
                    />
                  </Box>
                </>
              )}
            </>
          ) : (
            ""
          )}
          <Typography sx={classes.leadName}>Reminder</Typography>
          <Box mt={1} sx={classes.formPart}>
            <FormControl>
              <FormLabel id="demo-controlled-radio-buttons-group"></FormLabel>

              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={reminderStatus || "No Reminder"}
                onChange={(event) => {
                  handleChangeRadio?.(event);
                  if (event.target.value === "No Reminder") {
                    setReminderData?.((prev: any) => ({
                      ...(prev || {}),
                      _id: "",
                      title: "",
                      date: "",
                      time: "",
                      notes: "",
                    }));
                  }
                }}
              >
                {/* <FormControlLabel
                  value="Remark"
                  control={<Radio />}
                  label="Remark"
                /> */}
                <FormControlLabel
                  value="No Reminder"
                  control={<Radio />}
                  label="No Reminder"
                />
                <FormControlLabel
                  value="Schedule a Reminder"
                  control={<Radio />}
                  label="Schedule a Reminder"
                />
              </RadioGroup>
            </FormControl>
          </Box>
          {reminderStatus === "Schedule a Reminder" && (
            <Box sx={classes.inputPart}>
              <Box mt={1}>
                <YhInput
                  label="Title"
                  placeholder="Enter reminder title"
                  value={reminderData?.title || ""}
                  onChange={(event: any) => {
                    setReminderData((prevFormDataFields: any) => ({
                      ...prevFormDataFields,
                      ["title"]: event.target.value,
                    }));
                  }}
                />
              </Box>
              <Box mt={1.5} mb={2} sx={{ scrollMarginBottom: "96px" }}>
                <YhDateTimePicker
                  label="Date and Time"
                  value={
                    reminderData?.date && reminderData?.time
                      ? `${reminderData.date}T${reminderData.time}`
                      : ""
                  }
                  onChange={(val) => {
                    handleDateTimeChange({ target: { value: val } });
                  }}
                />
              </Box>
            </Box>
          )}
          <Box>
            {visibleReminders.length > 0 &&
              visibleReminders.slice(0, 4).map((item: any) => (
                <Box
                  mt={1}
                  key={String(item?._id || item?.title)}
                  sx={classes.reminderPart}
                >
                  <Box>
                    <Typography sx={classes.leadName1}>
                      {item?.title}
                    </Typography>
                    <Typography sx={{ fontSize: "10px" }}>
                      {formatReminderWhen(item)}
                    </Typography>
                    <Typography sx={{ fontSize: "10px" }}>
                      {item?.notes}
                    </Typography>
                  </Box>
                  <Box sx={classes.iconsPart}>
                    <Typography
                      onClick={() => fillReminderForm(item)}
                      sx={{
                        color: "#841C39",
                        fontSize: "12px",
                        cursor: "pointer",
                        marginRight: "8px",
                      }}
                    >
                      Edit
                    </Typography>
                    <Typography
                      onClick={async () => {
                        await handelRemoveReminder?.(item);
                        const leadId = String(dynamicGridValue?._id || "");
                        applyReminderList(
                          panelReminders.filter(
                            (row: any) =>
                              String(row?._id) !== String(item?._id)
                          )
                        );
                        if (String(reminderData?._id) === String(item?._id)) {
                          clearReminderForm();
                        }
                        await refreshReminderList(leadId);
                      }}
                      sx={{
                        color: "red",
                        fontSize: "12px",
                        cursor: "pointer",
                      }}
                    >
                      Remove
                    </Typography>
                  </Box>
                </Box>
              ))}

            {visibleReminders.length > 4 && (
              <Typography>
                <a
                  style={{
                    color: "blue",
                    fontSize: "12px",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    const type = "reminder";
                    if (!customerDetail) {
                      openCustomer({ ...dynamicGridValue, type });
                      setLeadData(dynamicGridValue);
                    } else {
                      setSelectedTab(3);
                    }
                  }}
                >
                  for More Reminder
                </a>
              </Typography>
            )}
          </Box>
          <Grid item xs={12} mt={1}>
            <Divider></Divider>
          </Grid>
          {/* {reminderStatus === "Remark" && ( */}
          <Box sx={classes.inputPart}>
            <Box mt={1}>
              <YhInput
                label={editingNoteId ? "Edit note" : "Notes"}
                multiline
                rows={4}
                placeholder={editingNoteId ? "Update this note..." : "Add a note..."}
                value={reminderData?.notes_remark || ""}
                onChange={(event) => {
                  setReminderData((prevFormDataFields: any) => ({
                    ...prevFormDataFields,
                    ["notes_remark"]: event.target.value,
                  }));
                }}
              />
              {editingNoteId ? (
                <button
                  type="button"
                  className="mt-1 text-xs font-semibold text-[#6B7280]"
                  onClick={() => {
                    setEditingNoteId("");
                    setReminderData?.((prev: any) => ({
                      ...(prev || {}),
                      notes_remark: "",
                    }));
                  }}
                >
                  Cancel edit
                </button>
              ) : null}
            </Box>
            {sortedNotes.length ? (
              <ol className="relative mt-4 list-none pl-0">
                <span
                  aria-hidden
                  className="absolute bottom-2 left-1/2 top-2 w-px -translate-x-1/2 bg-[#E8D0D8]"
                />
                {sortedNotes.map((item: any) => (
                  <li
                    key={String(item?._id || item?.createdAt || item?.notes)}
                    className="relative mb-4 w-[calc(50%-14px)] pr-1 text-left last:mb-0"
                  >
                    <span
                      aria-hidden
                      className="absolute -right-[18px] top-3 h-2.5 w-2.5 rounded-full border-2 border-[#841C39] bg-white"
                    />
                    <div className="rounded-xl border border-[#EEF0F5] bg-[#F9FAFB] px-2.5 py-2">
                      <div className="flex items-start justify-between gap-1">
                        <p className="text-[10px] leading-4 text-[#6B7280]">
                          {formatNoteWhen(item)}
                          {item?.updatedBy ? (
                            <span className="block">{item.updatedBy}</span>
                          ) : null}
                        </p>
                        <button
                          type="button"
                          className="shrink-0 text-[11px] font-semibold text-[#841C39]"
                          onClick={() => {
                            setEditingNoteId(String(item?._id || ""));
                            setReminderData?.((prev: any) => ({
                              ...(prev || {}),
                              notes_remark: item?.notes || "",
                            }));
                          }}
                        >
                          Edit
                        </button>
                      </div>
                      {item?.title ? (
                        <p className="mt-1 text-xs font-semibold text-[#111827]">
                          {item.title}
                        </p>
                      ) : null}
                      <p className="mt-1 whitespace-pre-wrap text-left text-xs leading-5 text-[#111827]">
                        {item?.notes || "—"}
                      </p>
                    </div>
                  </li>
                ))}
              </ol>
            ) : (
              <p className="mt-3 text-xs text-[#9CA3AF]">No notes yet.</p>
            )}
          </Box>
          {/* )} */}
        </Grid>

        {/* <Grid item xs={12}>
          <Divider></Divider>
        </Grid> */}
        <Grid item xs={12}>
          {additionalFields.length > 0 && (
            <Grid
              container
              gap={"10px"}
              display={"flex"}
              flexDirection={"column"}
            ></Grid>
          )}
        </Grid>
      </Grid>
      <div className="sticky bottom-0 z-20 -mx-3 mt-6 border-t border-[#EEF0F5] bg-white px-3 py-3 shadow-[0_-8px_16px_rgba(255,255,255,0.9)] screen:-mx-4 screen:px-4">
        <button
          type="button"
          disabled={savingPanel || assigning || savingCp}
          onClick={() => {
            void savePanel();
          }}
          className="h-10 w-full rounded-xl bg-[#841C39] text-sm font-semibold text-white disabled:opacity-60"
        >
          {savingPanel || assigning || savingCp ? "Saving…" : "Save"}
        </button>
      </div>
      <StageReasonModal
        open={stageReason.open}
        stageLabel={stageReason.stage}
        saving={savingStageReason}
        onCancel={() => {
          setStageReason({ open: false, stage: "" });
          setAutocompleteValue(
            stageOptions.find(
              (option) => option.label === dynamicGridValue?.stage
            )
          );
        }}
        onConfirm={confirmStageReason}
      />
    </>
  );
};

export default LeadDetailsComponent;
